import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { PricingProvider } from './contexts/PricingContext';
import './index.css';

// Ensure the container exists
const container = document.getElementById('microsoft-licensing-tool');
if (!container) {
  const newContainer = document.createElement('div');
  newContainer.id = 'microsoft-licensing-tool';
  document.body.appendChild(newContainer);
}

// Get the container (now guaranteed to exist) and render the app
const root = ReactDOM.createRoot(
  document.getElementById('microsoft-licensing-tool') as HTMLElement
);

root.render(
  <React.StrictMode>
    <PricingProvider>
      <App />
    </PricingProvider>
  </React.StrictMode>
);